import { getApiBaseUrl, getApiClient } from './serviceconfig';

const apiBaseUrl = getApiBaseUrl();

export async function getDebitNoteNumber(cookies, plantId, dnDate) {
    const url = `${apiBaseUrl}/debit_notes/debit_note_number/?plant_id=${plantId}&dn_date=${dnDate}`;
    return getApiClient(cookies).get(url).then((response) => response.data);
}

export async function getDebitNotes(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    const url = `${apiBaseUrl}/debit_notes/${query ? `?${query}` : ''}`;
    return getApiClient(cookies).get(url).then((response) => response.data);
}

export async function getDebitNoteDetails(cookies, debitNoteId) {
    return getApiClient(cookies).get(`${apiBaseUrl}/debit_notes/${debitNoteId}/`)
        .then((response) => response.data);
}

export async function printDebitNote(cookies, debitNoteId) {
    return getApiClient(cookies).get(`${apiBaseUrl}/debit_notes/${debitNoteId}/print_debit_note/`, {
        responseType: 'blob',
    }).then((response) => response.data);
}

export async function getInvoicesForDebitNote(cookies, plantId, customerId) {
    const url = `${apiBaseUrl}/debit_notes/invoices_for_customer/?plant_id=${plantId}&customer_id=${customerId}`;
    return getApiClient(cookies).get(url).then((response) => response.data);
}

export async function getDebitNoteInvoiceContext(cookies, invoiceId, excludeDnId = '') {
    let url = `${apiBaseUrl}/debit_notes/invoice_context/?invoice_id=${invoiceId}`;
    if (excludeDnId) {
        url += `&exclude_dn_id=${excludeDnId}`;
    }
    return getApiClient(cookies).get(url).then((response) => response.data);
}

export function createDebitNote(cookies, payload) {
    return getApiClient(cookies).post(`${apiBaseUrl}/debit_notes/`, payload)
        .then((response) => response.data);
}

export async function getDebitNoteEinvoiceConfig(cookies, plantId, dnDate, debitAmt = 0, invoiceId = '', buyerGstNo = '') {
    const gstParam = buyerGstNo ? `&buyer_gst_no=${encodeURIComponent(buyerGstNo)}` : '';
    const invoiceParam = invoiceId ? `&invoice_id=${invoiceId}` : '';
    const url = `${apiBaseUrl}/debit_notes/einvoice_config/?plant_id=${plantId}&dn_date=${dnDate}&debit_amt=${debitAmt || 0}${invoiceParam}${gstParam}`;
    return getApiClient(cookies).get(url).then((response) => response.data);
}

export function generateEDebitNote(cookies, debitNoteId) {
    return getApiClient(cookies)
        .post(`${apiBaseUrl}/debit_notes/${debitNoteId}/generate_edebit_note/`)
        .then((response) => response.data);
}

export function updateDebitNote(cookies, payload, debitNoteId) {
    return getApiClient(cookies).put(`${apiBaseUrl}/debit_notes/${debitNoteId}/`, payload)
        .then((response) => response.data);
}

export function cancelDebitNote(cookies, debitNoteId, payload = {}) {
    return getApiClient(cookies).patch(`${apiBaseUrl}/debit_notes/${debitNoteId}/`, payload)
        .then((response) => response.data);
}

export function deleteDebitNote(cookies, debitNoteId) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/debit_notes/${debitNoteId}/`)
        .then((response) => response.data);
}
